import { render, staticRenderFns } from "./ProfilePhoto.vue?vue&type=template&id=328442f7"
import script from "./ProfilePhoto.vue?vue&type=script&lang=js"
export * from "./ProfilePhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports